import React, { useMemo } from "react";
import { useParams } from "react-router";

import { useAppSelector } from "hooks/store";

import { interfaceElementsSelector } from "store/slices/themeSlice";

import { INTERFACE_ELEMENTS } from "themes/constants";

import QRCodeStub from "components/qr-code/stub-qr-code";

import { Layout, MediaPack, ConnectWithUs, QRCode } from "../../components";
import { Center, Divider, Skeleton } from "../../components/ui";
import poweredByImage from "../../resources/images/v74_33.png";
import FeedbackForm from "../../components/feedback-form";
import { useGetAttractionsQuery } from "../../store/api/attraction.api";
import { useGetUserQuery } from "../../store/api/user.api";
import { NAMES_MAP } from "../../constants/prefixConverter";

import styles from "./index.module.css";

const VideoPage = () => {
  const params = useParams();
  const { package_id } = params;
  const attractions = useGetAttractionsQuery(package_id || "");

  const { data, isLoading } = useGetUserQuery("");

  const interfaceElements = useAppSelector(interfaceElementsSelector);

  const renderPackageList = useMemo(
    () =>
      attractions.data && data ? (
        data.tickets?.map((ticket) => {
          const pack = data.packages.find(
            (pack) => pack.id === ticket.package_id
          );

          const isQrEnabled = interfaceElements.includes(
            INTERFACE_ELEMENTS.QR_CODE
          );

          // If no pack at all or has missing links for files
          const missingFileLinksOrPack =
            !pack ||
            pack?.package_items.length === 0 ||
            pack?.package_items.some((item) => !item.file_link);

          if (missingFileLinksOrPack) {
            if (!isQrEnabled) {
              return null;
            }
            if (ticket.qr) {
              return (
                <QRCode
                  key={ticket.id}
                  base64Data={ticket.qr}
                  attractionName={ticket.attraction_name}
                  ticketNumber={ticket.ticket_number}
                  className={styles.qrCode}
                />
              );
            } else {
              return (
                <QRCodeStub
                  key={ticket.id}
                  ticketNumber={ticket.ticket_number}
                  className={styles.qrCode}
                />
              );
            }
          } else {
            const attraction = attractions.data.find(
              (attraction) => attraction.id === pack.attraction_id
            );

            const prefix = NAMES_MAP[attraction?.name] || "";
            return (
              <MediaPack
                key={pack.id}
                pack={pack}
                ticketNumber={ticket.ticket_number}
                ticketPrefix={prefix}
                attraction={attraction}
                isProcessing={false}
              />
            );
          }
        })
      ) : (
        <></>
      ),
    [attractions, data, interfaceElements]
  );

  return (
    <Layout>
      <Center>
        <div className={styles.packagesContainer}>
          {renderPackageList}
          {isLoading && (
            <Skeleton count={4} className={styles.skeletonLoader} />
          )}
        </div>
      </Center>
      <Center>
        <div className={styles.poweredByContainer}>
          <a href="https://droneselfie.tech">
            <img
              className={styles.poweredByImage}
              src={poweredByImage}
              alt=""
            />
          </a>
        </div>
      </Center>
      <Divider />
      <Center>
        <div className={styles.feedbackContainer}>
          <FeedbackForm title="Остались вопросы? Напишите нам:" withShadow />
        </div>
      </Center>
      <Divider />
      <Center>
        <ConnectWithUs />
      </Center>
    </Layout>
  );
};

export default VideoPage;
